/**
 * Regras de exibição e validação de meios de pagamento.
 * API (PaymentDTO): { id: chave (string), name, icon (emoji), active: boolean }
 * Limites da API: id 3–50, name 3–30, icon até 16 caracteres.
 * A API grava a chave em minúsculas.
 */

export const KEY_MIN = 3;
export const KEY_MAX = 50;
export const NAME_MIN = 3;
export const NAME_MAX = 30;
export const ICON_MAX = 16;

/** Sugestões de ícone no formulário */
export const ICON_SUGGESTIONS = ["⚡️", "💳", "💵", "🏪", "📱", "🧾", "🎟️", "🏦", "💰", "🤝"];

/** Minúsculas e sem acento, para busca e comparação */
export const normalize = (s) =>
  String(s ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();

/** "Cartão de Crédito" → "cartao_de_credito" (só a-z, 0-9, _ e -) */
export const toKey = (text) =>
  normalize(text)
    .replace(/[^a-z0-9_-]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "")
    .slice(0, KEY_MAX);

/** Registro sem o campo continua ativo (padrão da API) */
export const isActive = (payment) => payment?.active !== false;

/**
 * Valida o formulário. `others` = demais meios (chave repetida).
 * Retorna { errors, payload } — payload só quando não há erros.
 */
export const validatePayment = ({ id, name, icon, active }, others = []) => {
  const errors = {};
  const key = toKey(id);
  const cleanName = String(name ?? "").trim().replace(/\s+/g, " ");
  const cleanIcon = String(icon ?? "").trim();

  if (!key) errors.id = "Informe a chave do meio de pagamento";
  else if (key.length < KEY_MIN) errors.id = `Use ao menos ${KEY_MIN} caracteres`;
  else if (others.some((p) => normalize(p.id) === key))
    errors.id = "Já existe um meio de pagamento com essa chave";

  if (!cleanName) errors.name = "Informe o nome exibido";
  else if (cleanName.length < NAME_MIN) errors.name = `Use ao menos ${NAME_MIN} caracteres`;
  else if (cleanName.length > NAME_MAX) errors.name = `Máximo de ${NAME_MAX} caracteres`;

  if (cleanIcon.length > ICON_MAX) errors.icon = `Máximo de ${ICON_MAX} caracteres`;

  if (Object.keys(errors).length) return { errors };
  return {
    errors,
    payload: { id: key, name: cleanName, icon: cleanIcon || null, active: Boolean(active) },
  };
};
